// @ vendors
const Immutable = require('immutable');
const moment = require('moment');
// @ constants
const actionTypes = require('../loansConstants/actionTypes');
const { DATE_FILTER_NONE } = require('constants/index');

const filtersInitialState = Immutable.fromJS({
    date: {
        from: '',
        to: '',
        selected: DATE_FILTER_NONE
    },
    isActive: false
});

const initialState = Immutable.fromJS({
    plan: [],
    isFetching: false,
    isFetchingNextPage: false,
    error: '',
    nextPage: '',
    filters: filtersInitialState
});

const mapPlan = (list, currency) => {
    let plan = [];
    list.forEach((movement) => {
        const item = {
            date: moment(movement.fechaAmortiz),
            installment: {
                currency,
                amount: movement.importeFranquicia || 0
            },
            amortizedCapital: {
                currency,
                amount: movement.capital || 0
            },
            interests: {
                currency,
                amount: movement.importeIntereses || 0
            },
            pendingCapital: {
                currency,
                amount: movement.capitalPendiente || 0
            }
        };

        plan.push(item);
    })

    return plan;
};

function loanRepaymentPlan(state = initialState, action) {
    let newState;
    switch (action.type) {
        case actionTypes.LOAN_REPAYMENT_PLAN_REQUEST:
            return state.mergeDeep({
                isFetching: true
            });
        case actionTypes.LOAN_REPAYMENT_PLAN_SUCCESS:
            newState = state.set('plan', Immutable.fromJS(mapPlan(action.payload.list, action.payload.currency)));
            return newState.mergeDeep({
                isFetching: false,
                nextPage: action.payload.nextPage,
                error: false
            });
        case actionTypes.LOAN_REPAYMENT_PLAN_FAILURE:
            return state.mergeDeep({
                isFetching: false,
                isFetchingNextPage: false,
                error: action.payload.error
            });
        case actionTypes.LOAN_REPAYMENT_PLAN_RESET:
            return initialState;
        case actionTypes.LOAN_REPAYMENT_PLAN_SET_FILTERS:
            return state.set('filters', Immutable.fromJS(action.payload.filters));
        case actionTypes.LOAN_REPAYMENT_PLAN_CLEAR_FILTERS:
            return initialState;
        case actionTypes.LOAN_REPAYMENT_PLAN_NEXT_PAGE_REQUEST:
            return state.mergeDeep({
                isFetchingNextPage: true
            });
        case actionTypes.LOAN_REPAYMENT_PLAN_NEXT_PAGE_SUCCESS:
            newState = state.set('plan', state.get('plan').concat(Immutable.fromJS(mapPlan(action.payload.list, action.payload.currency))));
            return newState.mergeDeep({
                isFetchingNextPage: false,
                nextPage: action.payload.nextPage
            });
        default:
            return state;
    }
}

module.exports = loanRepaymentPlan;
